import React from 'react';
const VideoOutline = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <g clipPath="url(#clip0_4421_10204)">
            <path d="M19.1668 5.8335L13.3335 10.0002L19.1668 14.1668V5.8335Z"
                stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.6668 4.1665H2.50016C1.57969 4.1665 0.833496 4.9127 0.833496 5.83317V14.1665C0.833496 15.087 1.57969 15.8332 2.50016 15.8332H11.6668C12.5873 15.8332 13.3335 15.087 13.3335 14.1665V5.83317C13.3335 4.9127 12.5873 4.1665 11.6668 4.1665Z"
                stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_4421_10204">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>


);

export default VideoOutline;